module.exports = __webpack_public_path__ + "static/media/noHomeworkIcon.8d6dfa95.svg";